import { Permission } from '@/lib/permissions/v1'
import { logParamKey, staffParamKey } from '@/composables/route'

export enum AdminStaffRouteName {
    Index = 'admin.staff.index',
    Create = 'admin.staff.create',
    Edit = 'admin.staff.edit',
    Activities = 'admin.staff.activities',
    Details = 'admin.staff.activities.details',
    Show = 'admin.staff.show',
}

export default {
    path: 'staff',
    component: () => import('@/views/admin/Index.vue'),
    meta: {
        label: 'Staff',
        auth: true,
        breadcrumb: false,
    },
    children: [
        {
            path: '',
            name: AdminStaffRouteName.Index,
            component: () => import('@/views/admin/staff/Index.vue'),
            meta: {
                label: 'Staff',
                auth: true,
                location: 'sidebar',
                icon: 'fal fa-user-hard-hat fa-fw',
                permission: Permission.StaffViewAny,
                group: 'main',
            },
            children: [
                {
                    path: 'create',
                    name: AdminStaffRouteName.Create,
                    component: () => import('@/views/admin/staff/Index.vue'),
                    meta: {
                        label: 'Create Staff',
                        auth: true,
                        location: 'sidebar',
                        icon: 'fal fa-user-hard-hat fa-fw',
                        permission: Permission.StaffCreate,
                        group: 'main',
                    },
                },
                {
                    path: `:${staffParamKey}/edit`,
                    name: AdminStaffRouteName.Edit,
                    component: () => import('@/views/admin/staff/Index.vue'),
                    meta: {
                        label: 'Edit Staff',
                        auth: true,
                        location: 'sidebar',
                        icon: 'fal fa-user-hard-hat fa-fw',
                        permission: Permission.StaffUpdate,
                        group: 'main',
                    },
                },
                {
                    path: `:${staffParamKey}/activities`,
                    name: AdminStaffRouteName.Activities,
                    component: () => import('@/views/admin/staff/Index.vue'),
                    meta: {
                        label: 'Edit Staff',
                        auth: true,
                        location: 'sidebar',
                        icon: 'fal fa-user-hard-hat fa-fw',
                        permission: Permission.EventViewAny,
                        group: 'main',
                    },
                    children: [
                        {
                            path: `:${logParamKey}/details`,
                            name: AdminStaffRouteName.Details,
                            component: () => import('@/views/admin/staff/Index.vue'),
                            meta: {
                                label: 'Activity Details',
                                auth: true,
                                location: 'sidebar',
                                icon: 'fal fa-user-hard-hat fa-fw',
                                permission: Permission.EventView,
                                group: 'main',
                            },
                        },
                    ],
                },
            ],
        },
    ],
}
